import _pt from "prop-types";
import InputAdornment from '@material-ui/core/InputAdornment';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Search from '@ori-ui/icons/lib/Search';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriAutoComplete'
};

const styles = theme => ({
  root: {
    zIndex: theme.zIndex.tooltip + 1,
    '& [class*="MuiFormControl-root"]': {
      zIndex: theme.zIndex.tooltip + 1
    }
  },
  paper: {
    marginTop: -23,
    padding: '20px 0 2px 0'
  },
  popper: {}
});

export const RENDER_INPUT_VARIANTS = {
  filled({
    InputProps,
    ...inputProps
  }) {
    return /*#__PURE__*/_jsx(TextField, {
      "data-testid": "filled-input",
      variant: "filled",
      InputProps: { ...InputProps,
        startAdornment: /*#__PURE__*/_jsx(InputAdornment, {
          position: "start",
          children: /*#__PURE__*/_jsx(Search, {})
        })
      },
      ...inputProps
    });
  },

  standard(inputProps) {
    return /*#__PURE__*/_jsx(TextField, {
      variant: "standard",
      "data-testid": "standard-input",
      ...inputProps
    });
  }

};
export function AutoComplete(props) {
  const {
    classes,
    renderInput,
    variant = 'standard',
    ...autoCompleteProps
  } = props;
  const internalRenderInput = useMemo(() => {
    if (renderInput) return renderInput;
    return RENDER_INPUT_VARIANTS[variant];
  }, [renderInput, variant]);
  return /*#__PURE__*/_jsx(Autocomplete, {
    popupIcon: false,
    renderInput: internalRenderInput,
    ...autoCompleteProps,
    classes: { ...classes,
      paper: clsx(variant === 'filled' && classes.paper)
    }
  });
}
AutoComplete.propTypes = {
  variant: _pt.oneOf(['filled', 'standard'])
};
export default withStyles(styles, componentConfig)(AutoComplete);